export const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match?.[1];
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; Path=/; Max-Age=-1`;
};
